import { PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { CTA } from '@superfunnel/types';
import Button from '@superfunnel/ui-core/v2/Button';
import FieldTitle from '@superfunnel/ui-core/v2/FieldTitle';
import { useState } from 'react';
import { uid } from 'uid';
import CreateCTAButtonModal from '../modals/CreateCTAButtonModal';
import QuillField from './QuillField';
import SortableList from './SortableList';

interface Props {
  title?: string;
  cta?: CTA[];
  onChange?: (cta: CTA[]) => void;
  disableEditAction?: boolean;
}

export default function CTAListEditor({
  title,
  cta,
  onChange,
  disableEditAction,
}: Props) {
  const [selectedCTA, setSelectedCTA] = useState<CTA>();
  const [editModalOpen, setEditModalOpen] = useState(false);

  return (
    <div>
      <CreateCTAButtonModal
        disableEditAction={disableEditAction}
        item={selectedCTA}
        open={editModalOpen}
        onClose={() => {
          setEditModalOpen(false);
          setSelectedCTA(undefined);
        }}
        onSave={(button) => {
          const index = cta?.findIndex((b) => b.id === selectedCTA?.id);
          if (cta && index != null && index !== -1) {
            const newArr = [...cta];
            newArr[index] = button;
            onChange?.(newArr);
          } else {
            onChange?.([...(cta || []), button]);
          }

          setEditModalOpen(false);
          setSelectedCTA(undefined);
        }}
      />
      <div className="flex items-center justify-between">
        <FieldTitle title={title || 'Buttons'} />

        <Button
          variant="ghost"
          size="icon"
          onClick={() => {
            setSelectedCTA({
              id: uid(8),
              title: 'Button',
              variant:
                cta?.[(cta?.length ?? 0) - 1]?.variant === 'primary'
                  ? 'secondary'
                  : 'primary',
              value: '',
              type: 'link',
            });
            setEditModalOpen(true);
          }}
        >
          <PlusIcon className="h-4 w-4" />
        </Button>
      </div>
      <SortableList
        items={cta ?? []}
        renderItemContent={(button) => {
          return (
            <QuillField
              key={JSON.stringify(button.title)}
              value={button.title}
              noDesign
              readOnly
            />
          );
        }}
        renderActions={(button) => {
          return (
            <>
              <Button
                variant="default"
                size="icon-sm"
                onClick={() => {
                  setSelectedCTA(button);
                  setEditModalOpen(true);
                }}
              >
                <PencilIcon className="h-4 w-4" />
              </Button>
              <Button
                variant="default"
                color="negative"
                size="icon-sm"
                onClick={() => {
                  onChange?.(cta?.filter((c) => c.id !== button.id) || []);
                }}
              >
                <TrashIcon className="h-4 w-4" />
              </Button>
            </>
          );
        }}
        onChange={(buttons) => {
          onChange?.(buttons);
        }}
      />
    </div>
  );
}
